export default {
  nav: {
    home: '首页',
    services: '产品服务',
    solutions: '解决方案',
    cases: '案例中心',
    partners: '合作伙伴',
    news: '公司动态',
    contact: '联系我们',
    smb: 'SMB服务',
    logo: '点一云科技'
  },
  hero: {
    title: '全球领先的云服务提供商',
    company: '点一云科技',
    subtitle: '通过技术创新和资源整合，为企业提供全方位的云服务解决方案，助力客户在AI时代实现全球业务拓展。',
    learnMore: '了解更多',
    contactUs: '联系我们',
    stats: {
      countries: '国家地区',
      availability: '服务可用性'
    },
    partners: {
      alt: '合作伙伴'
    }
  },
  services: {
    title: '产品服务',
    subtitle: '为企业提供全方位的云服务解决方案',
    items: {
      cloud: {
        title: '公有云代理',
        desc: '提供稳定、高效、安全的云计算服务，快速开户，7*24小时技术支持'
      },
      gpu: {
        title: 'GPU算力服务',
        desc: '专为AI训练、深度学习等场景打造的高性能GPU云主机'
      },
      ai: {
        title: 'AI海外矩阵营销',
        desc: '一站式解决方案：云手机 + 自动化机器人 + AIGC'
      },
      edge: {
        title: '边缘计算',
        desc: '200+全球边缘节点，提供高效的跨境网络服务'
      },
      security: {
        title: '人工智能应用',
        desc: '高效处理海量数据和复杂模型，为AI应用提供强大的计算能力和资源'
      },
      sms: {
        title: '国际营销短信服务',
        desc: '覆盖全球230个国家和地区，支持多语言，帮助企业简单、快速、低成本地拓展海外市场'
      }
    }
  },
  solutions: {
    title: '解决方案',
    subtitle: '为您的业务提供全方位的技术支持',
    items: {
      crossBorder: {
        title: '一站式出海解决方案',
        desc: '为企业提供完整的跨境业务平台，包含市场调研、策略规划、运营管理等全方位服务'
      },
      sms: {
        title: '国际营销短信服务',
        desc: '提供全球覆盖的短信发送服务，支持多语言、高到达率、快速稳定'
      },
      ddos: {
        title: '高防DDoS解决方案',
        desc: '提供强大的DDoS防护能力，保护您的业务免受各类网络攻击的威胁'
      },
      acceleration: {
        title: '跨境加速安全解决方案',
        desc: '通过全球节点网络，为您的跨境业务提供安全、稳定、高速的网络加速服务'
      }
    }
  },
  cases: {
    title: '案例中心',
    subtitle: '探索我们的成功案例，了解如何为客户创造价值',
    viewDetails: '查看详情',
    cards: {
      fengrui: {
        title: '广西锋锐信息技术服务有限公司上云成功案例',
        desc: '帮助企业完成 AWS 云迁移，提升系统性能，降低运维成本'
      },
      bairui: {
        title: '武汉柏锐科技有限公司上云成功案例',
        desc: '为游戏公司提供高性能云托管服务，支持全球玩家同时在线'
      },
      inventoryGame: {
        title: '某企业库存管理系统上云成功案例',
        desc: '为库存管理系统提供稳定可靠的云服务，提升用户体验'
      },
      inventoryStable: {
        title: '某企业数据管理系统上云成功案例',
        desc: '为企业提供强大的计算和存储资源，提高数据处理能力'
      }
    },
    items: {
      crossBorder: {
        title: '跨境电商解决方案',
        desc: '为某知名跨境电商平台提供一站式出海解决方案，包括支付系统、物流对接、多语言支持等，帮助客户快速拓展海外市场。',
        tags: {
          ecommerce: '跨境电商',
          payment: '支付系统',
          multilingual: '多语言'
        }
      },
      ddos: {
        title: '高防DDoS防护方案',
        desc: '为某游戏公司提供高防DDoS解决方案，通过智能防护系统有效抵御各类网络攻击，确保游戏服务器稳定运行。',
        tags: {
          protection: 'DDoS防护',
          gameserver: '游戏服务器',
          security: '网络安全'
        }
      }
    },
    backToHome: '返回首页'
  },
  news: {
    title: '公司动态',
    subtitle: '了解我们的最新发展',
    content: {
      paragraph1: '香港点一云科技有限公司是华为云、腾讯云、阿里云、亚马逊云等云厂科技核心级服务合作伙伴，致力于为客户提供云运维托管、成本管理、架构咨询、云迁移、数据库等服务，覆盖游戏、音视频直播、WEB3、零售电商、AI智能、新能源等行业。始终为客户提供可信赖的云上服务与解决方案，通过与各大云原厂的技术深度集成，为客户提供音视频直播、WEB3区块链生态、现代AI智能分析、游戏托管运维、电商服务、内容审核等多行业解决方案，并将持续探索云计算创新云改革，为客户提供更全面、高效、安全的云服务，助力其在数字化时代取得成功。',
      paragraph2: '点一云总部位于香港，在迪拜、深圳设有分公司，现有团队已有50+人，公司具有AWS、腾讯云、华为云等专业认证。成员均为在IT互联网行业服务三年以上，拥有丰富的技术以及经验。'
    }
  },
  partners: {
    title: '合作伙伴',
    items: {
      partner1: '华为云',
      partner2: '腾讯云',
      partner3: '阿里云',
      partner4: '亚马逊云',
      partner5: '微软云',
      partner6: '谷歌云'
    }
  },
  contact: {
    title: '联系我们',
    subtitle: '随时为您提供专业服务',
    email: {
      title: '邮箱',
      value: 'san@dycloud.ai'
    },
    phone: {
      title: '电话',
      value: '15989283653 刘先生'
    },
    wechat: {
      title: '微信',
      qrcode: '微信二维码',
      scan: '扫码添加微信'
    },
    copyright: '© 2024 香港点一云科技有限公司. All rights reserved.'
  }
} 